document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.bfcm2026-nav').forEach(function (root) {
    if (root.dataset.ready === 'true') return;
    root.dataset.ready = 'true';

    var buttons = Array.prototype.slice.call(root.querySelectorAll('[data-jump]'));
    var toggle = root.querySelector('[data-nav-toggle]');
    var bar = root.querySelector('.bfcm2026-nav__bar');

    // 箭头贴在导航右侧。点一次把整条导航滑出左侧，只留箭头并转 180°；再点一次滑回来。
    if (toggle && bar) {
      toggle.addEventListener('click', function () {
        var collapsed = root.classList.toggle('is-collapsed');
        toggle.setAttribute('aria-expanded', collapsed ? 'false' : 'true');
        var label = collapsed ? 'Show section menu' : 'Hide section menu';
        toggle.setAttribute('aria-label', label);
        toggle.setAttribute('data-ga-title', label);
        bar.inert = collapsed;
        if (collapsed) bar.setAttribute('aria-hidden', 'true');
        else bar.removeAttribute('aria-hidden');
      });
    }

    if (!buttons.length) return;

    // 点击后滚到 data-jump-id 相同的模块。减去顶栏高度，避免标题被 header 盖住。
    root.addEventListener('click', function (event) {
      var button = event.target.closest('[data-jump]');
      if (!button || !root.contains(button)) return;
      var id = button.getAttribute('data-jump');
      if (!id) return;
      var target = document.querySelector('[data-jump-id="' + id + '"]');
      if (!target) return;
      var header = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--header-height')) || 80;
      var top = target.getBoundingClientRect().top + window.pageYOffset - header - 16;
      var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      window.scrollTo({ top: Math.max(top, 0), behavior: reduce ? 'auto' : 'smooth' });
    });

    // 以视口上方约 35% 为触发线，滚过的模块对应按钮高亮。和周年导航同一判断方式。
    var mark = function () {
      var line = Math.min(window.innerHeight * 0.35, 220);
      var current = buttons[0];
      buttons.forEach(function (button) {
        var id = button.getAttribute('data-jump');
        if (!id) return;
        var target = document.querySelector('[data-jump-id="' + id + '"]');
        if (!target) return;
        if (target.getBoundingClientRect().top <= line) current = button;
      });
      buttons.forEach(function (button) {
        var active = button === current;
        button.classList.toggle('is-active', active);
        if (active) button.setAttribute('aria-current', 'true');
        else button.removeAttribute('aria-current');
      });
    };

    mark();
    window.addEventListener('scroll', mark, { passive: true });
    window.addEventListener('resize', mark);
  });
});
